import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import EPaymentMode from 'PMT/constants/EPaymentMode';

import BitUtils from 'PMT/utils/BitUtils';

// -- views
import OptionView from 'PMT/components/form/OptionView';

export default class PaymentModesForm extends Component {

  static defaultProps = {
    paymentModes: 0
  };

  static propTypes = {
    // PaymentModes
    paymentModes: PropTypes.number,

    onChange: PropTypes.func.isRequired
  };

  onToggleMode = (mode: PaymentMode) => {
    let mask = this.props.paymentModes;
    mask = BitUtils.toggle(mask, mode);
    this.props.onChange(mask);
  };

  //
  // Renderers
  //

  renderCreditCards() {
    return (
      <div>
        {this.renderOption(EPaymentMode.VISA, 'Visa')}
        {this.renderOption(EPaymentMode.MASTERCARD, 'Mastercard')}
        {this.renderOption(EPaymentMode.AMERICAN_EXPRESS, 'American express')}
      </div>
    );
  }

  renderCash() {
    return this.renderOption(EPaymentMode.CASH, I18n.tr('components.payment.modes.form.cash'));
  }

  renderRestaurantTickets() {
    return this.renderOption(EPaymentMode.RESTAURANT_TICKET, I18n.tr('components.payment.modes.form.restaurant_ticket'));
  }

  renderOption(paymentMode: PaymentMode, label: string) {
    return (
      <div>
        <OptionView
          isActivated={BitUtils.isSet(this.props.paymentModes, paymentMode)}
          onChange={() => this.onToggleMode(paymentMode)}
          label={label}
        />
      </div>
    );
  }

  render() {
    try {
    return (
      <div>
        {this.renderCreditCards()}
        {this.renderCash()}
        {this.renderRestaurantTickets()}
      </div>
    ); } catch (e) { console.error(e); }
  }

}



// WEBPACK FOOTER //
// ./scripts/components/payment/PaymentModesForm.js